import { useRef, useState } from 'react';
import { Button, message, Checkbox } from 'antd';
import type { CheckboxChangeEvent } from 'antd/es/checkbox';
import { UserOutlined, UnlockOutlined, SafetyCertificateOutlined } from '@ant-design/icons';
import { language } from "./../../locales";
import { EditForm, FormConfigType } from "./../../components/editForm";
import { authLogin_API, getAuthInfo_API, MemberServer } from "./../../server";
import { useRequest } from "ahooks";
import dayjs from 'dayjs';

import "./index.scss";
import loginPic from "./../../assets/img/loginPic.svg";

const server = MemberServer.Manager;
const lang = language?.config;
// const langHeader = language?.config.component.header;

// const currentLanguage = localStorage.getItem('language');
const currentRememberAccount = localStorage.getItem('loginAccount');

const formConfig: FormConfigType = [
  {
    type: 'input',
    field: 'username',
    placeholder: '请输入您的账号',
    prefix: <UserOutlined />,
    rules: [{ required: true, message: '请输入您的账号！' }]
  },
  {
    type: 'input',
    extendType: 'Password',
    field: 'password',
    placeholder: '请输入您的密码',
    prefix: <UnlockOutlined />,
    rules: [{ required: true, message: '请输入您的密码！' }]
  },
  {
    type: 'input',
    field: 'googleAuthCode',
    placeholder: '谷歌验证码（未绑定可不填）',
    prefix: <SafetyCertificateOutlined />,
    maxLength: 6,
    rules: [{
      validator: async (rule: any, value: any) => {
        if (value && !/^\d{6}$/.test(value)) {
          return Promise.reject('请输入6位数字谷歌验证码！');
        }
        return Promise.resolve();
      }
    }]
  }
];


const LoginPage = () => {
  const formRef: any = useRef(null);
  const [loading, setLoading] = useState(false);
  const [rememberAccount, setRememberAccount] = useState(!!currentRememberAccount);

  const login = () => {
    formRef.current.submit();
  }

  //获取权限
  const { run: getManagerRoles } = useRequest(server.getManagerRoles, {
    manual: true,
    onBefore: () => setLoading(true),
    onFinally: () => setLoading(false),
    onSuccess: (res: any) => {
      sessionStorage.setItem("functionPrivilege", JSON.stringify(res?.map((e: any) => e.PrivilegeCode)));

      const path = window.location.origin + '/mine';
      message.success("登录成功！");
      window.location.href = path;
    }
  });

  //获取登录信息
  const { run: getAuthInfo } = useRequest(getAuthInfo_API, {
    manual: true,
    onBefore: () => setLoading(true),
    onError: () => setLoading(false),
    onSuccess: (res: any) => {
      if (rememberAccount) {
        localStorage.setItem('loginAccount', formRef.current.getFieldValue('username'));
      }
      const { LastTime, CreatedAt, ...otherInfo } = res;
      const data = {
        LastTime: dayjs.unix(LastTime).format('YYYY-MM-DD HH:mm:ss'),
        CreatedAt: dayjs.unix(CreatedAt).format('YYYY-MM-DD HH:mm:ss'),
        ...otherInfo
      };
      sessionStorage.setItem('userInfo', JSON.stringify(data));

      getManagerRoles({});
    }
  });

  //登录
  const { run } = useRequest(authLogin_API, {
    manual: true,
    onBefore: () => setLoading(true),
    onError: () => setLoading(false),
    onSuccess: (res: any) => {
      sessionStorage.setItem("accessToken", res.AccessToken);
      getAuthInfo()
    }
  });


  const onFinish = (values: any) => {
    setLoading(true);
    run({
      Username: values.username,
      Password: values.password,
      GoogleAuthCode: (values.googleAuthCode || '').trim(),
    })
  }


  const formAttrsProps = {
    ref: formRef,
    initialValues: { username: currentRememberAccount },
    onFinish
  };

  return (
    <div className="login">
      <div className="loginBox">
        <div className="left">
          <div className='title'>
            <div className='w100p txtl'>欢迎登录</div>
            <div>{lang?.login.title}</div>
          </div>
          <div>
            <EditForm
              componentId="login"
              formAttrsProps={formAttrsProps}
              formData={{}}
              formConfig={formConfig}
            />
            <div className='flex align-center space-between'>
              <Checkbox checked={rememberAccount} onChange={(e: CheckboxChangeEvent) => setRememberAccount(e.target.checked)}>
                {lang?.login.rememberAccount}
              </Checkbox>
              {/* <Select
                size='small'
                popupMatchSelectWidth={false}
                options={[
                  {
                    label: langHeader?.cnZH,
                    value: 'zh-CN'
                  },
                  {
                    label: langHeader?.cnTW,
                    value: 'zh-TW'
                  },
                  {
                    label: langHeader?.enUS,
                    value: 'en-US'
                  },
                ]}
                value={currentLanguage}
                onChange={(v) => {
                  localStorage.setItem('language', v);
                  window.location.reload();
                }}
              /> */}
            </div>
            <Button className='mt20' loading={loading} block type="primary" shape="round" onClick={login}>{lang?.login.loginBtn}</Button>
          </div>
          <div className="copyright">{lang?.login.copyright}</div>
        </div>
        <img className="right" src={loginPic} alt="" />
      </div>
    </div>
  )
}

export default LoginPage;
